module.exports = __webpack_public_path__ + "img/paid-coupon.cf6719b3.svg";